import { Subject } from 'rxjs'
import apiResponse from '../../../../../services/apiResponse'
import UpdateRepository from '../Repositories/UpdateRepository'


class UpdateBloc {

    detailChannel = new Subject();
    updateChannel = new Subject();
    listPegawaiChannel = new Subject()
    listUnitKerjaChannel = new Subject()
    listJabatanChannel = new Subject()
    regionChannel = new Subject()
     
    repository = new UpdateRepository()

    constructor() {
        this.detailChannel.next({status: apiResponse.INITIAL})
        this.updateChannel.next({status: apiResponse.INITIAL})
        this.listPegawaiChannel.next({status: apiResponse.INITIAL})
        this.listUnitKerjaChannel.next({status: apiResponse.INITIAL})
        this.listJabatanChannel.next({status: apiResponse.INITIAL})

    }

    fetchDetail = async (query) => {
        this.detailChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchDetail(query).then((result) => {
            this.detailChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.detailChannel.next({status: apiResponse.ERROR, data: error})
        })
    }

    fetchUpdate = async (query) => {
        this.updateChannel.next({status: apiResponse.LOADING})
        await this.repository.fetchUpdate(query).then((result) => {
            this.updateChannel.next({status: apiResponse.COMPLETED, data: result})
        }).catch((error) => {
            this.updateChannel.next({status: apiResponse.ERROR, data: error})
        })
    }
    fetchRegion = async (query) => {
        try {
            this.regionChannel.next({ status: apiResponse.LOADING})
            await this.repository.fetchRegion(query).then((result) => {
                this.regionChannel.next({ status: apiResponse.COMPLETED, data: result })
            }).catch((error) => {
                this.regionChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Error fetching region')
        }
    }
    fetchListPegawai = async (query) => {
        try {
            this.listPegawaiChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListPegawai(query).then((result) => {
                this.listPegawaiChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listPegawaiChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }
    
    fetchListUnitKerja = async (query) => {
        try {
            this.listUnitKerjaChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListUnitKerja(query).then((result) => {
                this.listUnitKerjaChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listUnitKerjaChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }


    fetchListJabatan = async (query) => {
        try {
            this.listJabatanChannel.next({status: apiResponse.LOADING})
            await this.repository.fetchListJabatan(query).then((result) => {
                this.listJabatanChannel.next({ status: apiResponse.COMPLETED, data: result})
            }).catch((error) => {
                this.listJabatanChannel.next({ status: apiResponse.ERROR, data: error})
            })
        } catch (error) {
            console.log('rxjs', 'Channel Unsubscribed') 
        }
    }

}

export default UpdateBloc